'use client';
import React from 'react';
import { SessionContext } from '@benzinga/session-context';
import { AuthenticationManager } from '@benzinga/session';
import { useIsUserLoggedIn } from './useIsUserLoggedIn';
import { cookieCleaner } from '@benzinga/frontend-utils';
import Hooks from '@benzinga/hooks';

export const useClearBrowserStorage = () => {
  const session = React.useContext(SessionContext);
  const isLoggedIn = useIsUserLoggedIn();
  const authenticationManager = session.getManager(AuthenticationManager);

  const broadcastLogout = () => {
    if (typeof BroadcastChannel === 'undefined') return;
    const channel = new BroadcastChannel('auth-manager');
    channel.postMessage({ type: 'logout' });
    channel.close();
  };

  Hooks.useEffectDidMount(() => {
    async function clearBrowserStorageAndRedirect() {
      const forcedSession = await authenticationManager.getAuthSession(true);
      if (isLoggedIn || forcedSession?.ok) {
        await authenticationManager.logout();
      }
      cookieCleaner();
      broadcastLogout();
    }
    clearBrowserStorageAndRedirect();
  });
};
